<template>
  <div class="content">
    <BlockUI
      v-if="this.blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-card-title>
        <TitleWithButton
          title="Manutenções e Sinistros"
          buttonText="Adicionar"
          :buttonFunction="newBreakdown"
        />
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-autocomplete
                  v-model="searchPlate"
                  :items="vehicles"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="id"
                  placeholder="Placa do veículo"
                  prepend-icon="mdi-car"
                />
              </v-col>
            </v-flex>            

            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-autocomplete
                  v-model="searchClients"
                  :items="clients"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="id"
                  placeholder="Condomínio"
                  prepend-icon="mdi-office-building"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="start">
                <v-autocomplete
                  v-model="searchBreakdownType"
                  :items="breakdownType"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="id"
                  placeholder="Tipo de Sinistro"
                  prepend-icon="mdi-car-off"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="center">
                <v-btn                  
                  block
                  class=" mt-4 white--text"                  
                  color="primary"
                  @click="filter"
                >
                  Pesquisar
                </v-btn>
              <!-- </v-col>
            </v-flex>
            <v-flex xs12 md3 sm6>
              <v-col align="center"> -->
                <v-btn
                  block
                  color="success"
                  class=" mt-4 white--text"
                  @click="exportToExcel"
                >
                  Exportar
                  <v-icon right>mdi-file-excel</v-icon>
                </v-btn>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card-text>
        <v-flex class="mx-3 my-2" xs12 md12>
          <v-row justify="start">
            <v-col align="start">
              <v-data-table
                ref="myTable"
                :headers="headers"
                :items="carServiceData"
                item-key="name"
                group-key="category"
                class="elevation-1 mt-2"
                :footer-props="{
                  'items-per-page-text': 'Linhas por página:',
                }"
                no-data-text="Nenhuma Sinistro cadastrada"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>{{ item.vehicle_id | formatVehicle(vehicles, item.vehicle_id)}}</td>
                    <td>{{ item.client_id | formatClient(clients, item.client_id) }}</td>
                    <td>{{ item.breakdown_type_id | formatBreakdown( breakdownType, item.breakdown_type_id ) }}</td>                    
                    <td><span :class="'s'+item.responsible_identified">{{ item.responsible_identified | formatStatus }}</span> </td>
                    <td><span :class="'s'+item.charged">{{ item.charged | formatStatus }}</span> </td>
                    <td><span :class="'s'+item.received">{{ item.received | formatStatus }}</span> </td>                    
                    <td>{{ item.budget_value | formatValue }}</td>
                    <td>{{ item.charged_value | formatValue }}</td>
                    <td>{{ item.type_charge_id | formatCharge(typeCharge, item.type_charge_id) }}</td>
                    <td>{{ item.supply_local | formatSupply(suppliers, item.supply_local) }}</td>
                    <td>{{ item.date_breakdown | formatDate() }}</td>
                    <td>{{ item.repair_forecast | formatDate() }}</td>
                    <td>{{ item.repair_completion | formatDate() }}</td>                    
                    <td><span :class="'s'+item.status">{{ item.status | formatStatus }}</span> </td>
                    <td>
                      <ActionButton
                        v-if="situation == true"
                        message="Editar Sinistro"
                        icon="edit"
                        @onclick="editItem(item)"
                      />
                      <ActionButton
                        v-if="situation == true"
                        message="Excluir Sinistro"
                        icon="delete"
                        color="error"
                        @onclick="changeService(item, 'delete')"
                      />
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-flex>
      </v-card-text>
    </v-card>

    <v-layout justify="center">
      <v-dialog v-model="breakdown_type_modal" persistent max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">{{
              this.breakdown.id ? 'Editar Registro' : 'Novo Registro'
            }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-layout wrap>                
                <v-flex xs12 sm6 md5>
                  <v-select
                    v-model="breakdown.vehicle_id"
                    :items="vehicles"
                    item-text="name"
                    item-value="id"
                    label="Veículo: *"
                    required
                  ></v-select>
                </v-flex>                  
                
                <v-flex xs12 sm6 md5 style="padding-left: 30px;">
                  <v-select
                    v-model="breakdown.client_id"
                    :items="clients"
                    item-text="name"
                    item-value="id"
                    label="Condomínio: *"
                    required
                  ></v-select>
                </v-flex>
                <hr />
                <v-flex xs12 sm6 md5>
                  <v-select
                    v-model="breakdown.breakdown_type_id"
                    :items="breakdownType"
                    item-text="name"
                    item-value="id"
                    label="Tipo: *"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md5></v-flex>                

                <v-layout>
                  <v-flex xs12 sm6 md5>
                    <v-checkbox
                      v-model="breakdown.responsible_identified"
                      label="Responsável Identificado"
                    >
                    </v-checkbox>
                  </v-flex>
                
                  <v-flex xs12 sm6 md5 style="padding-left: 30px;">
                    <v-checkbox
                      v-model="breakdown.charged"
                      label="Cobrado"
                    >
                    </v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm6 md5 style="padding-left: 30px;">
                    <v-checkbox
                      v-model="breakdown.received"
                      label="Recebido"
                    >
                    </v-checkbox>
                  </v-flex>                  
                </v-layout>
                <v-flex xs12 sm12 md12></v-flex>

                <v-flex xs12 sm12 md5>
                  <label for="model">Valor do orçamento: </label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon1"
                        >R$</span
                      >
                    </div>
                    <money
                      v-model="breakdown.budget_value"
                      v-bind="money"
                      class="form-control"
                    ></money>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md5>
                  <label for="model">Valor Cobrado: </label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon1"
                        >R$</span
                      >
                    </div>
                    <money
                      v-model="breakdown.charged_value"
                      v-bind="money"
                      class="form-control"
                    ></money>
                  </div>
                </v-flex>
                <v-flex xs12 sm6 md5>
                  <v-select
                    v-model="breakdown.type_charge_id"
                    :items="typeCharge"
                    item-text="name"
                    item-value="id"
                    label="Tipo de cobrança: "
                    required
                  ></v-select>
                </v-flex>                
                <v-flex xs12 sm6 md5 style="padding-left: 30px;">
                  <v-select
                    v-model="breakdown.supply_local"
                    :items="suppliers"
                    item-text="name"
                    item-value="id"
                    label="Oficina: "
                    required
                  ></v-select>                    
                  </v-flex>
                <hr />
                <v-flex xs12 sm12 md5>
                  <span class="subheading font-weight-medium">
                    <span class="checkin-text">Data do sinistro*</span>
                  </span>
                  <div style="margin: 10px 0px 15px 0px;" class="form-control">
                    <datetime
                      input-id="inputDate"
                      type="datetime"
                      value-zone="America/Sao_Paulo"
                      zone="America/Sao_Paulo"
                      v-model="breakdown.date_breakdown"
                    ></datetime>
                  </div>
                </v-flex>
                
                <v-flex xs12 sm6 md5 style="padding-left: 30px;">
                  <span class="subheading font-weight-medium">
                    <span class="checkin-text">Términio Prev </span>
                  </span>
                  <div style="margin: 10px 0px 15px 0px;" class="form-control">
                    <datetime
                      input-id="inputDate"
                      type="datetime"
                      value-zone="America/Sao_Paulo"
                      zone="America/Sao_Paulo"
                      v-model="breakdown.repair_forecast"
                    ></datetime>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md5>
                  <span class="subheading font-weight-medium">
                    <span class="checkin-text">Términio Real </span>
                  </span>
                  <div style="margin: 10px 0px 15px 0px;" class="form-control">
                    <datetime
                      input-id="inputDate"
                      type="datetime"
                      value-zone="America/Sao_Paulo"
                      zone="America/Sao_Paulo"
                      v-model="breakdown.repair_completion"
                    ></datetime>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md12>                                
                </v-flex>
                <v-layout>
                  <v-flex xs12 >
                    <v-checkbox
                      v-model="breakdown.status"
                      label="Concluído"
                    >
                    </v-checkbox>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="breakdown_type_modal = false"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="formBreakdown()"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <modalPadrao
        :showModal="modalConfirmacao.open"
        :ifTitle="true"
        :Title="modalConfirmacao.title"
        :ifTwoBtn="true"
        :TextFirstBtn="'Não'"
        :TextSecondBtn="'Sim'"
        @btnUm="modalConfirmacao.open = false"
        @btnDois="actionModalConfirmacao"
      ></modalPadrao>
    </v-layout>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import { Datetime } from 'vue-datetime';
import BreakdownController from '../../controllers/BreakdownController';
import SupplierController from '../../controllers/SupplierController';
import ConfigurationController from '../../controllers/ConfigurationController';
import VehicleController from '../../controllers/VehicleController';
import ClientController from '../../controllers/ClientController';
import moment from 'moment';
import Constants from '../../models/constants/Constants';
import ActionButton from '../shared/ActionButtonsTemplate';
import TitleWithButton from '../../UIComponents/titleWithButton.vue';
import modalPadrao from '../shared/ModalPadrao.vue';


export default {
  components: {
    Datetime,
    ActionButton,
    TitleWithButton,
    modalPadrao,
  },
  data() {
    return {
      breakdownController: new BreakdownController(this.$resource),
      configurationController: new ConfigurationController(this.$resource),
      supplierController: new SupplierController(this.$resource),
      vehicleController: new VehicleController(this.$resource),
      clientController: new ClientController(this.$resource),
      clienteId: localStorage.getItem('client_id'),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      carServiceData: [],
      clients: [],
      typeCharge: [],
      vehicles: [],
      breakdownType: [],
      suppliers: [],
      situation: true,
      searchPlate: null, //id do veículo
      searchClients: null,
      searchBreakdownType: null, //id do condomínio
      breakdown: {
        vehicle_id: '',
        client_id: '',
        breakdown_type_id: '',
        date_breakdown: '',
        status: false,
        repair_completion: '',
        budget_value: null,
        charged_value: null
      },
      headers: [        
        { text: 'VEÍCULO', value: 'vehicle_id' },        
        { text: 'CONDOMINIO', value: 'client_id' },
        { text: 'TIPO', value: 'breakdown_type_id' },
        { text: 'RESP. IDENTIFICADO', value: 'responsible_identified' },
        { text: 'COBRADO', value: 'charged' },
        { text: 'RECEBIDO', value: 'received' },
        { text: 'ORÇAMENTO', value: 'budget_value' },
        { text: 'VALOR COBRADO', value: 'charged_value' },
        { text: 'TIPO COBRANÇA', value: 'type_charge_id' },
        { text: 'OFICINA', value: 'supply_local' },        
        { text: 'DT SINISTRO', value: 'date_breakdown' },
        { text: 'TÉRM. PREV.', value: 'repair_forecast' },
        { text: 'TÉRM. REAL', value: 'repair_completion' },
        { text: 'STATUS', value: 'status' },
        { text: 'AÇÕES', value: 'action', sortable: false },
      ],
      breakdown_type_modal: false,
      modalConfirmacao: {
        open: false,
        title: '',
        action: '',
      },
      configurations: {
        price_hour: {
          value: null,
        },
        payment: {
          value: null,
        },
        longitude_visualization: {
          value: null,
        },
        latitude_visualization: {
          value: null,
        },
        request_end_wait_timespan_in_minutes: {
          value: null,
        },
      },
      properties: {
        'prepend-icon': 'mdi-currency-brl',
      },
      options: {
        locale: 'pt-BR',
        length: 8,
        precision: 2,
      },
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false,
      },
      endCreate: false
    };
  },
  created() {
    this.getConfigurations();
    this.loadData();
    this.getClients();
    this.getVehicles();
    this.getBreakdownType();
    this.getAllSupplier();
    this.getTypeCharge();
    this.endCreate = true;
  },
  methods: {
    changeService(item, action) {
      this.actionItem = item;
      this.action = action;
      this.modalConfirmacao.title = 'Deseja excluir o registro de Sinistro?';
      this.modalConfirmacao.action = action;
      this.modalConfirmacao.open = true;
    },
    async actionModalConfirmacao() {
      switch (this.action) {
        case 'finish':
          return this.finishMaintenance();
        case 'delete':
          return this.deleteService();
      }
    },
    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },
    getConfigMinuteStep() {
      let valueNotEmpty = !(
        this.configurations.request_end_wait_timespan_in_minutes.value === ''
      );
      if (
        this.configurations.request_end_wait_timespan_in_minutes.value ||
        valueNotEmpty
      ) {
        return Number(
          this.configurations.request_end_wait_timespan_in_minutes.value
        );
      }
      return Number(Constants.CONFIG_MINUTE_STEP_DATE_TIME_DEFAULT);
    },
    async getConfigurations() {
      let configs = await this.configurationController.getAll(this.clienteId);
      this.configurations = configs;
    },
    async formBreakdown() {      
      try {
        if(this.breakdown.repair_completion == '')
          delete this.breakdown.repair_completion;
        if(this.breakdown.repair_forecast == '')
          delete this.breakdown.repair_forecast;

        if (this.breakdown.id) {
          this.updateBreakdown();
          return;
        }
        this.createBreakdown();  
      } catch (error) {
        console.log(error)
      }      
    },
    async loadData({ withFilters = false } = {}) {
      this.carServiceData = [];
      this.blockScreen = true;

      this.breakdownController
        .getAllBreakdown({
          serviceTypeId: withFilters ? this.searchBreakdownType : null,
          vehicleId: withFilters ? this.searchPlate : null,
          clientId: this.searchClients,
        })
        .then(
          response => {
            if (response.body.length > 0) {
              this.carServiceData = response.body;
            }
            this.searchPlate = null;
            this.searchClients = null;
            this.searchBreakdownType = null;
          },
          err => console.log(err)
        );

      this.blockScreen = false;
    },
    validaForm(value){
      console.log('validaForm')
      if( 
        value.vehicle_id == '' 
        || value.client_id == ''  
        || value.breakdown_type_id == '' 
        || value.date_breakdown == ''
      ){        
        console.log('false')
        this.$awn.alert('Preencha todos os campo obrigatórios "*".');
        return false;
      }
      console.log('true')
      return true;
    },
    filter() {
      this.loadData({
        withFilters: true,
      });

      this.searchPlate = null;
      this.searchBreakdownType = null;
    },
    async getBreakdownType() {
      await this.breakdownController.getBreakdownType().then(
        breakdownType => {          
          breakdownType.body.forEach(element => {
            this.breakdownType.push({
              id: element.id,
              value: { id: element.id, valor: element.description },
              text: element.description,
              name: `${element.description}`,
            });
          });
        },
        err => console.log(err)
      );
    },
    async getAllSupplier() {
      await this.supplierController.getAllSupplier().then(
        suppliers => {          
          suppliers.body.forEach(element => {
            this.suppliers.push({
              id: element.id,
              value: { id: element.id, valor: element.description },
              text: element.description,
              name: `${element.description}`,
            });
          });
        },
        err => console.log(err)
      );
    },
    async getTypeCharge() {
      await this.breakdownController.getTypeCharge().then(
        typeCharge => {          
          typeCharge.body.forEach(element => {
            this.typeCharge.push({
              id: element.id,
              value: { id: element.id, valor: element.description },
              text: element.description,
              name: `${element.description}`,
            });
          });
        },
        err => console.log(err)
      );
    },
    async getVehicles() {
      await this.vehicleController.getAllVehicles().then(
        vehicles => {
          vehicles.forEach(element => {
            this.vehicles.push({
              id: element.id,
              value: { id: element.id, valor: element.vehicle_model.model },
              text: element.vehicle_model.model,
              name: `${element.vehicle_model.model} - ${element.plate}`,
              client_id: element.client.id,
            });
          });
        },
        err => console.log(err)
      );
    },
    async getClients() {
      await this.clientController.getAllClients().then(
        clients => {
          clients.forEach(element => {
            this.clients.push({
              id: element.id,
              name: element.name,
            });
          });
        },
        err => console.log(err)
      );
    },
    newBreakdown() {
      //Limpa formulário
      this.breakdown = {
        vehicle_id: '',
        client_id: '',
        breakdown_type_id: '',
        date_breakdown: '',
        status: false,
        repair_completion: ''
      };
      this.breakdown_type_modal = true;
    },
    editItem(item) {      
      this.breakdown.id = item.id;
      this.breakdown.vehicle_id = item.vehicle_id;
      this.breakdown.client_id = item.client_id;
      this.breakdown.breakdown_type_id = item.breakdown_type_id;
      this.breakdown.repair_completion = item.repair_completion;
      this.breakdown.repair_forecast = item.repair_forecast;
      this.breakdown.responsible_identified = item.responsible_identified;
      this.breakdown.budget_value = item.budget_value/100;    
      this.breakdown.charged_value = item.charged_value/100;
      this.breakdown.charged = item.charged;
      this.breakdown.received = item.received;
      this.breakdown.supply_local = item.supply_local;
      this.breakdown.status = item.status;
      this.breakdown.type_charge_id = item.type_charge_id;
      this.breakdown.date_breakdown = moment(item.date_breakdown).toISOString(true);
      this.breakdown_type_modal = true;      
    },
    formtAmount(vl){      
      return vl *100;
    },
    async createBreakdown() {
      try {       
        if( !this.validaForm(this.breakdown) ){
          return;
        }         
        this.breakdown.budget_value = this.formtAmount(this.breakdown.budget_value);
        this.breakdown.charged_value = this.formtAmount(this.breakdown.charged_value);
        let response = await this.breakdownController.createBreakdown(
          this.breakdown
        );
        this.breakdown_type_modal = false;
        this.loadData();
        if (response.body.message)
          return this.$awn.success(response.body.message);
        return this.$awn.success('Sinistro criada com sucesso');
      } catch (err) {
        this.$awn.alert(err.body);
      }
    },
    async updateBreakdown() {
      try {        
        if( !this.validaForm(this.breakdown) ){
          
          return;
        }
        this.breakdown.budget_value = this.breakdown.budget_value*100;
        this.breakdown.charged_value = this.breakdown.charged_value*100;
        
        let response = await this.breakdownController.updateBreakdown(
          this.breakdown
        );
        this.breakdown_type_modal = false;
        this.loadData();
        if (response.body.message)
          return this.$awn.success(response.body.message);
        return this.$awn.success('Sinistro alterada com sucesso');
      } catch (err) {
        this.$awn.alert(err.body);
      }
    },
    async deleteService() {
      try {
        await this.breakdownController.deleteBreakdownById(
          this.actionItem.id
        );
        this.loadData();
        this.modalConfirmacao.open = false;
        return this.$awn.success('Sinistro excluída com sucesso');
      } catch (err) {
        this.$awn.alert('Falha ao excluir Sinistro');
        console.log(err);
      }
    },    
    exportToExcel() {
      const sheet = XLSX.utils.table_to_sheet(this.$refs.myTable.$el);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, sheet, 'Tabela');
      XLSX.writeFile(workbook, 'dados.xlsx');
    }
  },
  computed: {
    listVehicles() {
      return this.vehicles;
    }
  },
  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY');
      }
      return 'Sem data';
    },
    formatBoolean(value) {
      return value ? 'SIM' : 'NÃO';
    },
    formatValue(value) {
      let valueFloat = parseFloat(value / 100);
      let formatedValue = 'R$ ' + valueFloat.toFixed(2).replace('.', ',');
      return formatedValue;
    },
    formatVehicle(value, vehicles ){
      if(value){
        let vehicle = vehicles.find(objeto => objeto.id === value);
        if(vehicle == null) return null;
        return Object.keys(vehicle).includes('name') ? vehicle.name : null;
      } return null;
    },
    formatBreakdown(value, breakdowns){
      if(value){
        let breakdown = breakdowns.find(objeto => objeto.id === value);
        if(breakdown == null) return null;
        return Object.keys(breakdown).includes('name') ? breakdown.name : null;        
      } return null;
    },
    formatClient(value, clients){
      if(value){
        let client = clients.find(objeto => objeto.id === value);
        if(client == null) return null;
        return Object.keys(client).includes('name') ? client.name : null;
      } return null;
    },
    formatCharge(value, typeCharge){
      if(value ){
        let charge = typeCharge.find(objeto => objeto.id === value);
        if(charge == null) return null;
        return Object.keys(charge).includes('name') ? charge.name : null;
      } return null;
    },
    formatSupply(value, suppliers){
      if(value ){
        let supplier = suppliers.find(objeto => objeto.id == value);
        if(supplier == null) return null;
        return Object.keys(supplier).includes('name') ? supplier.name : null;
      } return null;
    },
    formatStatus(value){
      if(value == 1)
        return "Sim";
      else
        return "Não";
    }
  },
};
</script>

<style scoped>
.inputs >>> #inputDate {
  width: 100%;
  text-align: center;
}

.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}
.colorSelectedBack {
  background-color: var(--secondary-color);
}
.sizeTop {
  height: 48px;
}

hr {
  width: 2px;
  height: 25px;
  margin: auto 0;
}

.button {
  margin: 0 auto;
}

.button-text {
  text-transform: none;
}

.second {
  margin-bottom: 46px;
}

.sizePart {
  width: 49%;
  text-align: center;
}

.cardBottom {
  position: absolute;
  bottom: 56px;
  border-radius: 0;
}

.cardRadius {
  border-radius: 4px;
}

.carSelected {
  border: 2px solid var(--secondary-color) !important;
}

.cardTitle {
  font-size: 18px;
}

.cardContent {
  display: flex;
  justify-content: space-between;
}

.creditCard {
  display: inline-flex;
}

.coupon {
  display: flex;
}

.couponBtn {
  outline: none;
}

.vehicle {
  display: flex;
}

.modelo {
  font-size: 16px;
  color: #181f4d;
}

.caption {
  color: #181f4d;
}

.contentLeft {
  display: inline-block;
  width: 60%;
}

.contentRight {
  display: inline-block;
  width: 40%;
}

.vehicleImg {
  margin-left: -10px;
}
.autocomplete__inputs input {
  height: 44px !important;
}
.vdatetime {
  width: 100%;
}

.inputs {
  border: 1px solid rgb(173, 173, 173);
  border-radius: 6px;
  align-content: middle;
  width: 90%;
  margin: 0 auto;
  display: flex;
}

.border {
  border: 2px solid grey;
}

.borderBottom {
  border-bottom: 1px solid gray;
}

.bottom {
  margin-bottom: 60px;
}

.fab {
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: 0 0;
  display: flex;
}

.floatBtn {
  position: absolute;
  bottom: 56px;
  width: 100%;
  margin: 0 auto;
}

.colorBtn {
  background-color: var(--primary-color) !important;
}

.checkin {
  background-color: var(--secondary-color);
}

.checkin-text {
  color: var(--secondary-color);
}

.checkinBorder {
  border: 1px solid var(--secondary-color) !important;
}

.checkout {
  background-color: var(--orange-color) !important;
}

.checkout-text {
  color: var(--orange-color);
}

.checkoutBorder {
  border: 1px solid var(--orange-color) !important;
}

.total {
  color: #181f4d;
}

.sfalse {
  color: red;
}

.strue {
  color: green;
}


</style>

